import React from 'react';

export function StateSkeleton({ lines = 3 }) {
  return (
    <div className="ui-state skeleton" aria-busy="true">
      {Array.from({ length: lines }).map((_, index) => (
        <div key={index} className="skeleton-line" />
      ))}
    </div>
  );
}

export function StateEmpty({ title = 'Chưa có dữ liệu', description = '' }) {
  return (
    <div className="ui-state empty">
      <strong>{title}</strong>
      {description ? <p>{description}</p> : null}
    </div>
  );
}

export function StateError({ message = 'Đã xảy ra lỗi', onRetry }) {
  return (
    <div className="ui-state error" role="alert">
      <strong>{message}</strong>
      {onRetry ? (
        <button type="button" className="ui-state-btn" onClick={onRetry}>
          Thử lại
        </button>
      ) : null}
    </div>
  );
}

export function InlineStatus({ type = 'info', message }) {
  if (!message) return null;
  return <div className={`inline-status ${type}`}>{message}</div>;
}
